import logo from './logo.svg';
import './App.css';
import Counter from './component/Counter';

function App() {
  return (
    <>
       <Counter></Counter>
    </>
  );
}

export default App;
